import i18n from '@viterbit/web-app/i18n'


const useLocale = () => i18n.resolvedLanguage

export default useLocale